import { FileAttachment } from 'foundations-components/transitional/components/FileAttachment';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
const MIME_MAP = {
  CSV: 'text/csv',
  TXT: 'text/plain',
  MD: 'text/markdown',
  JSON: 'application/json',
  PDF: 'application/pdf'
};
export function FileBlock({
  block
}) {
  const {
    base64Data,
    fileType,
    filename: originalFilename
  } = block;
  const mime = MIME_MAP[fileType] || 'application/octet-stream';
  const url = `data:${mime};base64,${base64Data}`;
  const paddingChars = base64Data.endsWith('==') ? 2 : base64Data.endsWith('=') ? 1 : 0;
  const sizeKb = Math.round((base64Data.length * 3 / 4 - paddingChars) / 1024);
  const filename = originalFilename || `file.${fileType.toLowerCase()}`;
  return /*#__PURE__*/_jsx("div", {
    "data-block-type": "file",
    style: {
      maxWidth: 280
    },
    children: /*#__PURE__*/_jsx("a", {
      href: url,
      download: filename,
      style: {
        textDecoration: 'none',
        color: 'inherit'
      },
      children: /*#__PURE__*/_jsx(FileAttachment, {
        fileName: filename,
        fileInfo: unescapedText('breezeEngineChatComponents.file.fileInfo', {
          size: sizeKb > 0 ? unescapedText('breezeEngineChatComponents.file.sizeKb', {
            size: sizeKb
          }) : unescapedText('breezeEngineChatComponents.file.sizeLessThanOneKb'),
          fileType
        }),
        fileType: mime,
        size: "lg"
      })
    })
  });
}